<div class="card">
  <div #ref class="card-body" [formGroup]="formCyclesConfig">
    <h5 class="card-title mt-3">Recursos</h5>

    <div class="row">
      <div class="col-md-6">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="checkAllCycles"
            (change)="checkAll($event, ref, formCyclesConfig)">
          <label class="form-check-label" for="checkAllCycles">
            Selecionar Tudo
          </label>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-body pt-0">
        <div class="d-flex flex-lg-row flex-column">
          <div class="col mt-3 border-card-right pb-4 pb-lg-0">
            <div class="card-title">
              <h6 class="mt-4 mb-2">CICLO 1</h6>
            </div>


            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="show_planning_step_one"
                formControlName="show_planning_step_one">
              <label class="form-check-label" for="show_planning_step_one">
                <strong>Cronograma</strong>
              </label>
            </div>



            <p class="mb-0 mt-2"><strong>Dados Iniciais:</strong></p>

            <div class="row pl-2 mb-2">
              <div class="col-md">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="show_planning_step_two_search_strategy"
                    formControlName="show_planning_step_two_search_strategy">
                  <label class="form-check-label" for="show_planning_step_two_search_strategy">
                    Estratégia de Busca
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="show_planning_step_two_hypotheses"
                    formControlName="show_planning_step_two_hypotheses">
                  <label class="form-check-label" for="show_planning_step_two_hypotheses">
                    Hipóteses
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="show_planning_step_two_selection_criteria"
                    formControlName="show_planning_step_two_selection_criteria">
                  <label class="form-check-label" for="show_planning_step_two_selection_criteria">
                    Critérios de Seleção
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="show_planning_step_three"
                    formControlName="show_planning_step_three">
                  <label class="form-check-label" for="show_planning_step_three">
                    <strong>Avaliação Metodológica</strong>
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="show_planning_step_four"
                    formControlName="show_planning_step_four">
                  <label class="form-check-label" for="show_planning_step_four">
                    <strong>Extração de Dados</strong>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col mt-3">

            <div class="card-title">
              <h6 class="mt-4 mb-2">CICLO 2</h6>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="show_development_step_five"
                formControlName="show_development_step_five">
              <label class="form-check-label" for="show_development_step_five">
                <strong>Bibliometria</strong>
              </label>
            </div>

            <div class="row">
              <div class="col-md">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="show_development_step_six"
                    formControlName="show_development_step_six">
                  <label class="form-check-label" for="show_development_step_six">
                    <strong>Análise de Dados</strong>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer px-0">
      <button (click)="saveCyclesConfig()" class="button button-green w-25">Salvar</button>
    </div>
  </div>
</div>